import axios, { AxiosRequestConfig } from 'axios';
import { AlfaKodeOversiktResponse } from '../models/NV06AlfaOversikt';
import CSharpUtils from './CSharpUtils';
import Utils from './Utils';

export const fetchAlfaKodeOversikt = (
  companyId: number,
  page: number,
  pageSize: number,
  search?: string,
  sortBy?: string,
  sortDirection?: string,
) => {
  const config: AxiosRequestConfig = {
    method: 'get',
      url: `${Utils.URL_ADDRESS}${Utils.WEBAPI_PATH}/product/alfaGroupOverview`,
    params: {
      CompanyId: companyId,
      Page: page,
      PageSize: pageSize,
      ...(search ? { Search: search } : {}),
      ...(sortBy ? { SortBy: sortBy } : {}),
      ...(sortDirection ? { SortDirection: sortDirection } : {}),
    },
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${CSharpUtils.Get_Token}`,
    },
    responseType: 'json',
    timeout: 30000,
  };

  return axios.request<AlfaKodeOversiktResponse>(config);
};
